import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  navigationItem: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 0),
    borderRight: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
    [theme.breakpoints.up('lg')]: {
      borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
    },
    [theme.breakpoints.down('lg')]: {
      borderTop: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
    },
    color: theme.palette.text.secondary,

    '&:last-child': {
      borderRight: 'none',
    },

    '&:hover': {
      color: theme.palette.text.primary,
      cursor: 'pointer',
    },

    '&.active': {
      boxShadow: `inset 0 -${theme.spacing(0.125)} 0 0 ${theme.palette.primary.main}`,
      color: theme.palette.text.primary,
    },
  },
}));
